var React = require('react');

function ArrowLFilled (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"L","clipPath":"url(#clip0_702_15689)","key":0},React.createElement("path",{"id":"Vector","d":"M3.27835e-07 7.5L7.5 15L7.5 0","fill":"#CF2029"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_702_15689"},React.createElement("rect",{"width":"15","height":"7.5","fill":"white","transform":"matrix(4.37114e-08 -1 -1 -4.37114e-08 7.5 15)"})))]);
}

ArrowLFilled.defaultProps = {"width":"8","height":"15","viewBox":"0 0 8 15","fill":"none"};

module.exports = ArrowLFilled;

ArrowLFilled.default = ArrowLFilled;
